export default [
  {
    path: '/pledge-2025/index',
    name: 'index',
    component: () => import('@/views/pledge-2025'),
    meta: {
      title: '2025高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2025/pledgepersonal',
    name: 'pledgepersonal',
    component: () => import('@/views/pledge-2025/pledgepersonal'),
    meta: {
      title: '2025高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2025/pledgelist',
    name: 'pledgelist',
    component: () => import('@/views/pledge-2025/pledgelist'),
    meta: {
      title: '2025高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2025/pledgeform',
    name: 'pledgeform',
    component: () => import('@/views/pledge-2025/pledgeform'),
    meta: {
      title: '2025高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2025/pledgeupload',
    name: 'pledgeupload',
    component: () => import('@/views/pledge-2025/pledgeupload'),
    meta: {
      title: '2025高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2025/blessing',
    name: 'blessing',
    component: () => import('@/views/pledge-2025/blessing'),
    meta: {
      title: '送出你的寄语，为大家加油助威！'
    }
  },
  {
    path: '/pledge-2025/myblessing',
    name: 'myblessing',
    component: () => import('@/views/pledge-2025/myblessing'),
    meta: {
      title: '送出你的寄语，为大家加油助威！'
    }
},
  {
    path: '/pledge-2025/mypledge',
    name: 'mypledge',
    component: () => import('@/views/pledge-2025/mypledge'),
    meta: {
      title: '送出你的寄语，为大家加油助威！'
    }
  },{
    path: '/pledge-2025/pledgeinfo',
    name: 'pledgeinfo',
    component: () => import('@/views/pledge-2025/pledgeinfo'),
    meta: {
      title: '2025高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2025/blessing',
    name: 'blessing',
    component: () => import('@/views/pledge-2025/blessing'),
    meta: {
      title: '送出你的学霸寄语，为参加2025高考的学弟学妹们加油助威！'
    }
  },
  {
    path: '/pledge-2025/myblessing',
    name: 'myblessing',
    component: () => import('@/views/pledge-2025/myblessing'),
    meta: {
      title: '送出你的学霸寄语，为参加2025高考的学弟学妹们加油助威！'
    }
  },
  {
    path: '/pledge-2025/lotteryRecord',
    name: 'lotteryRecord',
    component: () => import('@/views/pledge-2025/lotteryRecord'),
    meta: {
      title: '写下你的誓词，赢超级大利！'
    }
  },
  {
    path: '/pledge-2025/lottery',
    name: 'lottery',
    component: () => import('@/views/pledge-2025/lottery'),
    meta: {
      title: '写下你的誓词，赢超级大利！'
    }
  },
  {
    path: '/pledge-2025/scene',
    name: 'scene',
    component: () => import('@/views/pledge-2025/scene'),
    meta: {
      title: '2025高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2025/pledgeformscene',
    name: 'pledgeformscene',
    component: () => import('@/views/pledge-2025/pledgeformscene'),
    meta: {
      title: '2025高考誓师大会-高考直通车'
    }
  }
]
